import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet, useRouterState } from "@tanstack/react-router";
import { Toaster } from "sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { NotFound, RouteError } from "@/features/public/NotFound";
import { BuildVersionFooter } from "@/features/shell/BuildVersionFooter";
import { useTheme } from "@/lib/theme";

function Root() {
  const { dark } = useTheme();
  const inApp = useRouterState({ select: (s) => /^\/app(?:\/|$)/.test(s.location.pathname) });
  return (
    <TooltipProvider>
      <Outlet />
      {inApp ? null : <BuildVersionFooter />}
      <Toaster
        theme={dark ? "dark" : "light"}
        position="bottom-right"
        offset={20}
        mobileOffset={{ bottom: 76 }}
        toastOptions={{
          classNames: {
            toast: "!rounded-lg !bg-elevated !text-fg !shadow-lg !border-0 !font-sans",
            description: "!text-fg-muted",
          },
        }}
      />
    </TooltipProvider>
  );
}

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: Root,
  notFoundComponent: () => <NotFound />,
  errorComponent: ({ reset }) => <RouteError reset={reset} />,
});
